import AppConstants from '../config/app.constants';

let CarrierBranchService = function ($http, $q) {

    let createBranchGroup = (carrierId, branches) => {
        return $http
            .post(AppConstants.api + `/carrier-branch/create-carrier-branch`, {
                carrierId,
                branches
            })
            .then((res) => {
                return res.data
            })
    };

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/carrier-branch`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let updateBranchGroup = (carrierId, branches) => {
        return $http
            .post(AppConstants.api + `/carrier-branch/update-carrier-branch`, {
                carrierId,
                branches
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        createBranchGroup,
        all,
        updateBranchGroup
    }
}

CarrierBranchService.$inject = ['$http', '$q'];

export default CarrierBranchService;


// WEBPACK FOOTER //
// ./client/app/services/carrier-branch.service.js